import { create } from 'zustand'

const useModalsStore = create((set) => ({
  showEditSectionModal: false,
  showExportScheduleModal: false,
  showEditStudentScheduleModal: false,
  editSectionModalInfo: {
    section_id: null,
    data_id: null,
    section_type: null,
    course_period_id: null,
  },
  editStudentScheduleModalInfo: {
    student_id: null,
    student_navigation_ids: null,
  },
  setShowEditSectionModal: (show) => set({ showEditSectionModal: show }),
  setEditSectionModalInfo: (info) => set(state => ({ editSectionModalInfo: { ...state.editSectionModalInfo, ...info } })),
  toggleShowEditSectionModal: () => set(state => ({ showEditSectionModal: !state.showEditSectionModal })),
  setEditStudentScheduleModal: (show) => set({ showEditStudentScheduleModal: show }),
  setEditStudentScheduleModalInfo: (info) => set(state => ({ editStudentScheduleModalInfo: { ...state.editStudentScheduleModalInfo, ...info } })),
  setShowExportScheduleModal: (show) => set({ showExportScheduleModal: show }),
}));

export const useModalsData = () => useModalsStore((state) => ({
  showEditSectionModal: state.showEditSectionModal,
  showExportScheduleModal: state.showExportScheduleModal,
  showEditStudentScheduleModal: state.showEditStudentScheduleModal,
  editSectionModalInfo: state.editSectionModalInfo,
  editStudentScheduleModalInfo: state.editStudentScheduleModalInfo,
}));
export const useModalsActions = () => useModalsStore((state) => ({
  setShowEditSectionModal: state.setShowEditSectionModal,
  setEditSectionModalInfo: state.setEditSectionModalInfo,
  toggleShowEditSectionModal: state.toggleShowEditSectionModal,
  setEditStudentScheduleModal: state.setEditStudentScheduleModal,
  setEditStudentScheduleModalInfo: state.setEditStudentScheduleModalInfo,
  setShowExportScheduleModal: state.setShowExportScheduleModal,
}));


export default useModalsStore
